import universal from 'react-universal-component';

export default universal(() => import('./Duplicate'));



// WEBPACK FOOTER //
// ./src/app/views/Custom/Duplicate/index.js